import { FormGroup } from "@blueprintjs/core";

import RemoteConditionWidget from "common/form/widgets/RemoteConditionWidget";
import { ConditionTypeRegistry } from "../ConditionTypeRegistry";
import { IConditionType } from "../IConditionType";

interface IRemoteCondition {
	uuid: string;
}

const RemoteConditionCondition: IConditionType<IRemoteCondition> = {
	type: "remote",
	label: "Remote Condition",
	icon: "diagram-tree",
	evaluate: (value, state) => {
		if (!value.uuid) {
			// skip if no UUID set
			return true;
		}

		const externalId = state.config.conditions[value.uuid];
		return !!externalId && !!state.user.conditions[externalId];
	},
	renderField: (value, onChange) => (
		<FormGroup label="Remote Condition">
			<RemoteConditionWidget
				value={value.uuid}
				onChange={(uuid) => onChange({...value || {}, uuid})}
			/>
		</FormGroup>
	)
};

export default ConditionTypeRegistry.register(RemoteConditionCondition);



// WEBPACK FOOTER //
// ./src/common/form/fields/condition/conditionTypes/RemoteConditionCondition.reg.tsx